let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jsxWn")).then(() => parcelRequire('c265f'));